import Button from '../../../Button'
import { ClampingText } from '../../../ClampingText'

import { PROFILE_INFO_WIDGET_NOTES_CLAMPING_LINES_COUNT } from './ProfileInfoWidgetNotes.constants'

import * as styles from './ProfileInfoWidgetNotes.module.css'

function ProfileInfoWidgetNotes({ notes }) {
  return (
    <div className={styles.ProfileInfoWidgetNotes}>
      <ClampingText
        Button={Button.Text}
        clampingLinesCount={PROFILE_INFO_WIDGET_NOTES_CLAMPING_LINES_COUNT}
        fullText={notes}
      />
    </div>
  )
}

export default ProfileInfoWidgetNotes
